import moment from 'moment';

export default (value: Date | null | undefined, format = 'LL') =>
  value ? moment(value).format(format) : '';
